import { DropdownItem } from '@shared/components/dropdown/dropdown.model';
import { SortOption } from '@shared/models/sort-option';
import { SortDirection } from '@shared/pipes/array/sort-by.pipe';

export const sortItems: DropdownItem<SortOption>[] = [
  {
    id: 'name-asc',
    label: 'Name',
    value: { field: 'name', direction: SortDirection.Ascending }
  },
  {
    id: 'contactType-asc',
    label: 'Type',
    value: { field: 'contactType', direction: SortDirection.Ascending }
  },
  {
    id: 'entityType-asc',
    label: 'Category',
    value: { field: 'entityType', direction: SortDirection.Ascending }
  }
];
